/**
 * API の getPrincipalId / getPrincipalLoginDisplay と揃える。
 * chat の app.js とも手動で同期すること。
 */

export const APP_USER_ID_MAX_LEN = 128;

const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

type Claim = { typ?: string; val?: unknown };

export type PrincipalLike = {
  userId?: string;
  userDetails?: string;
  claims?: Claim[];
};

/** API の clientPrincipal.claimValToString と同じ（/.auth/me と x-ms-client-principal で形がずれることがある）。 */
function claimValToString(val: unknown): string {
  if (typeof val === 'string') return val.trim();
  if (Array.isArray(val)) {
    const first = val.find((x) => typeof x === 'string') as string | undefined;
    return first ? first.trim() : '';
  }
  return '';
}

function claimValue(p: PrincipalLike, typ: string): string {
  const raw = p.claims?.find((c) => c.typ === typ)?.val;
  return claimValToString(raw);
}

/** 投稿・編集権限・アバター URL 用の安定 ID（オブジェクト ID 優先）。 */
export function principalToStableAuthorId(p: PrincipalLike | null | undefined): string {
  if (!p) return '';
  let oid = claimValue(p, 'http://schemas.microsoft.com/identity/claims/objectidentifier');
  if (!oid || !GUID_RE.test(oid)) {
    const o = claimValue(p, 'oid');
    if (o && GUID_RE.test(o)) oid = o;
    else if (!GUID_RE.test(oid || '')) oid = '';
  }
  if (oid) return oid.toLowerCase();
  const sub = claimValue(p, 'sub');
  if (sub) return sub.trim().toLowerCase().slice(0, APP_USER_ID_MAX_LEN);
  const userId = String(p.userId ?? '').trim();
  if (userId) return userId.toLowerCase().slice(0, APP_USER_ID_MAX_LEN);
  return '';
}

